import React from 'react';
import store from '@Store';
import { SUPPORT_HUB_LINK } from '@Containers/CasNumber/constants';
import { newToastMessage } from '@Containers/ToastMessages/ToastMessagesActions';
import Button from '@Components/Button';

const CasNumberErrorToastMessageContent = () => {
  return (
    <div className="cas-number-toast-message__content">
      The service is currently unavailable, please try again later. To learn more <Button
      buttonConfig={{
        label: 'click here',
        type: 'link',
        size: 'sm',
        color: 'blue',
        e2eName: 'cas-api-error-help',
        aTag: true,
        href: SUPPORT_HUB_LINK,
      }}
      target="_blank"
    />.
    </div>
  );
};

export const showCasNumberErrorToastMessage = () =>
  newToastMessage({
    iconId: '#icon-cas-number',
    title: 'We cannot retrieve the CAS Registry Number',
    content: <CasNumberErrorToastMessageContent/>,
    className: 'els-toast-message cas-number-toast-message',
    closeBtn: true,
  });

export default CasNumberErrorToastMessageContent;
